// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { BuildingFloodRiskSchema } from "./BuildingFloodRiskSchema";
import {
  instanceOfBuildingFloodRiskSchema,
  BuildingFloodRiskSchemaFromJSON,
  BuildingFloodRiskSchemaFromJSONTyped,
  BuildingFloodRiskSchemaToJSON,
} from "./BuildingFloodRiskSchema";
import type { CalculateDrainagePatternSchema } from "./CalculateDrainagePatternSchema";
import {
  instanceOfCalculateDrainagePatternSchema,
  CalculateDrainagePatternSchemaFromJSON,
  CalculateDrainagePatternSchemaFromJSONTyped,
  CalculateDrainagePatternSchemaToJSON,
} from "./CalculateDrainagePatternSchema";
import type { CalculateFloorLevelSchema } from "./CalculateFloorLevelSchema";
import {
  instanceOfCalculateFloorLevelSchema,
  CalculateFloorLevelSchemaFromJSON,
  CalculateFloorLevelSchemaFromJSONTyped,
  CalculateFloorLevelSchemaToJSON,
} from "./CalculateFloorLevelSchema";
import type { ComputeMaxWaterdepthSchema } from "./ComputeMaxWaterdepthSchema";
import {
  instanceOfComputeMaxWaterdepthSchema,
  ComputeMaxWaterdepthSchemaFromJSON,
  ComputeMaxWaterdepthSchemaFromJSONTyped,
  ComputeMaxWaterdepthSchemaToJSON,
} from "./ComputeMaxWaterdepthSchema";
import type { Create2dFloodModelSchema } from "./Create2dFloodModelSchema";
import {
  instanceOfCreate2dFloodModelSchema,
  Create2dFloodModelSchemaFromJSON,
  Create2dFloodModelSchemaFromJSONTyped,
  Create2dFloodModelSchemaToJSON,
} from "./Create2dFloodModelSchema";
import type { CreateBasicHydroDataSchema } from "./CreateBasicHydroDataSchema";
import {
  instanceOfCreateBasicHydroDataSchema,
  CreateBasicHydroDataSchemaFromJSON,
  CreateBasicHydroDataSchemaFromJSONTyped,
  CreateBasicHydroDataSchemaToJSON,
} from "./CreateBasicHydroDataSchema";
import type { DefineStudyAreaSchema } from "./DefineStudyAreaSchema";
import {
  instanceOfDefineStudyAreaSchema,
  DefineStudyAreaSchemaFromJSON,
  DefineStudyAreaSchemaFromJSONTyped,
  DefineStudyAreaSchemaToJSON,
} from "./DefineStudyAreaSchema";
import type { DelineateBasinsSchema } from "./DelineateBasinsSchema";
import {
  instanceOfDelineateBasinsSchema,
  DelineateBasinsSchemaFromJSON,
  DelineateBasinsSchemaFromJSONTyped,
  DelineateBasinsSchemaToJSON,
} from "./DelineateBasinsSchema";
import type { ExtractDatasetSchema } from "./ExtractDatasetSchema";
import {
  instanceOfExtractDatasetSchema,
  ExtractDatasetSchemaFromJSON,
  ExtractDatasetSchemaFromJSONTyped,
  ExtractDatasetSchemaToJSON,
} from "./ExtractDatasetSchema";
import type { ModelTrackerSchema } from "./ModelTrackerSchema";
import {
  instanceOfModelTrackerSchema,
  ModelTrackerSchemaFromJSON,
  ModelTrackerSchemaFromJSONTyped,
  ModelTrackerSchemaToJSON,
} from "./ModelTrackerSchema";
import type { RanaDtacogoV1Schema } from "./RanaDtacogoV1Schema";
import {
  instanceOfRanaDtacogoV1Schema,
  RanaDtacogoV1SchemaFromJSON,
  RanaDtacogoV1SchemaFromJSONTyped,
  RanaDtacogoV1SchemaToJSON,
} from "./RanaDtacogoV1Schema";
import type { SimulateRainfallSchema } from "./SimulateRainfallSchema";
import {
  instanceOfSimulateRainfallSchema,
  SimulateRainfallSchemaFromJSON,
  SimulateRainfallSchemaFromJSONTyped,
  SimulateRainfallSchemaToJSON,
} from "./SimulateRainfallSchema";
import type { SimulateRainfallStandardEventsSchema } from "./SimulateRainfallStandardEventsSchema";
import {
  instanceOfSimulateRainfallStandardEventsSchema,
  SimulateRainfallStandardEventsSchemaFromJSON,
  SimulateRainfallStandardEventsSchemaFromJSONTyped,
  SimulateRainfallStandardEventsSchemaToJSON,
} from "./SimulateRainfallStandardEventsSchema";
import type { SimulationTrackerSchema } from "./SimulationTrackerSchema";
import {
  instanceOfSimulationTrackerSchema,
  SimulationTrackerSchemaFromJSON,
  SimulationTrackerSchemaFromJSONTyped,
  SimulationTrackerSchemaToJSON,
} from "./SimulationTrackerSchema";

/**
 * @type ProcessTagSchemas
 *
 * @export
 */
export type ProcessTagSchemas =
  | ({ tag: "building_flood_risk" } & BuildingFloodRiskSchema)
  | ({ tag: "calculate_drainage_pattern" } & CalculateDrainagePatternSchema)
  | ({ tag: "calculate_floor_level" } & CalculateFloorLevelSchema)
  | ({ tag: "compute_max_waterdepth" } & ComputeMaxWaterdepthSchema)
  | ({ tag: "create_2d_flood_model" } & Create2dFloodModelSchema)
  | ({ tag: "create_basic_hydro_data" } & CreateBasicHydroDataSchema)
  | ({ tag: "define_study_area" } & DefineStudyAreaSchema)
  | ({ tag: "delineate_basins" } & DelineateBasinsSchema)
  | ({ tag: "extract_dataset" } & ExtractDatasetSchema)
  | ({ tag: "model_tracker" } & ModelTrackerSchema)
  | ({ tag: "rana-dtacogo-v1" } & RanaDtacogoV1Schema)
  | ({ tag: "simulate_rainfall" } & SimulateRainfallSchema)
  | ({ tag: "simulate_rainfall_standard_events" } & SimulateRainfallStandardEventsSchema)
  | ({ tag: "simulation_tracker" } & SimulationTrackerSchema);

export function ProcessTagSchemasFromJSON(json: any): ProcessTagSchemas {
  return ProcessTagSchemasFromJSONTyped(json, false);
}

export function ProcessTagSchemasFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProcessTagSchemas {
  if (json == null) {
    return json;
  }
  switch (json["tag"]) {
    case "building_flood_risk":
      return Object.assign({}, BuildingFloodRiskSchemaFromJSONTyped(json, true), {
        tag: "building_flood_risk",
      } as const);
    case "calculate_drainage_pattern":
      return Object.assign({}, CalculateDrainagePatternSchemaFromJSONTyped(json, true), {
        tag: "calculate_drainage_pattern",
      } as const);
    case "calculate_floor_level":
      return Object.assign({}, CalculateFloorLevelSchemaFromJSONTyped(json, true), {
        tag: "calculate_floor_level",
      } as const);
    case "compute_max_waterdepth":
      return Object.assign({}, ComputeMaxWaterdepthSchemaFromJSONTyped(json, true), {
        tag: "compute_max_waterdepth",
      } as const);
    case "create_2d_flood_model":
      return Object.assign({}, Create2dFloodModelSchemaFromJSONTyped(json, true), {
        tag: "create_2d_flood_model",
      } as const);
    case "create_basic_hydro_data":
      return Object.assign({}, CreateBasicHydroDataSchemaFromJSONTyped(json, true), {
        tag: "create_basic_hydro_data",
      } as const);
    case "define_study_area":
      return Object.assign({}, DefineStudyAreaSchemaFromJSONTyped(json, true), {
        tag: "define_study_area",
      } as const);
    case "delineate_basins":
      return Object.assign({}, DelineateBasinsSchemaFromJSONTyped(json, true), {
        tag: "delineate_basins",
      } as const);
    case "extract_dataset":
      return Object.assign({}, ExtractDatasetSchemaFromJSONTyped(json, true), {
        tag: "extract_dataset",
      } as const);
    case "model_tracker":
      return Object.assign({}, ModelTrackerSchemaFromJSONTyped(json, true), {
        tag: "model_tracker",
      } as const);
    case "rana-dtacogo-v1":
      return Object.assign({}, RanaDtacogoV1SchemaFromJSONTyped(json, true), {
        tag: "rana-dtacogo-v1",
      } as const);
    case "simulate_rainfall":
      return Object.assign({}, SimulateRainfallSchemaFromJSONTyped(json, true), {
        tag: "simulate_rainfall",
      } as const);
    case "simulate_rainfall_standard_events":
      return Object.assign({}, SimulateRainfallStandardEventsSchemaFromJSONTyped(json, true), {
        tag: "simulate_rainfall_standard_events",
      } as const);
    case "simulation_tracker":
      return Object.assign({}, SimulationTrackerSchemaFromJSONTyped(json, true), {
        tag: "simulation_tracker",
      } as const);
    default:
      return json;
  }
}

export function ProcessTagSchemasToJSON(json: any): any {
  return ProcessTagSchemasToJSONTyped(json, false);
}

export function ProcessTagSchemasToJSONTyped(
  value?: ProcessTagSchemas | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  switch (value["tag"]) {
    case "building_flood_risk":
      return Object.assign({}, BuildingFloodRiskSchemaToJSON(value), {
        tag: "building_flood_risk",
      } as const);
    case "calculate_drainage_pattern":
      return Object.assign({}, CalculateDrainagePatternSchemaToJSON(value), {
        tag: "calculate_drainage_pattern",
      } as const);
    case "calculate_floor_level":
      return Object.assign({}, CalculateFloorLevelSchemaToJSON(value), {
        tag: "calculate_floor_level",
      } as const);
    case "compute_max_waterdepth":
      return Object.assign({}, ComputeMaxWaterdepthSchemaToJSON(value), {
        tag: "compute_max_waterdepth",
      } as const);
    case "create_2d_flood_model":
      return Object.assign({}, Create2dFloodModelSchemaToJSON(value), {
        tag: "create_2d_flood_model",
      } as const);
    case "create_basic_hydro_data":
      return Object.assign({}, CreateBasicHydroDataSchemaToJSON(value), {
        tag: "create_basic_hydro_data",
      } as const);
    case "define_study_area":
      return Object.assign({}, DefineStudyAreaSchemaToJSON(value), {
        tag: "define_study_area",
      } as const);
    case "delineate_basins":
      return Object.assign({}, DelineateBasinsSchemaToJSON(value), {
        tag: "delineate_basins",
      } as const);
    case "extract_dataset":
      return Object.assign({}, ExtractDatasetSchemaToJSON(value), {
        tag: "extract_dataset",
      } as const);
    case "model_tracker":
      return Object.assign({}, ModelTrackerSchemaToJSON(value), { tag: "model_tracker" } as const);
    case "rana-dtacogo-v1":
      return Object.assign({}, RanaDtacogoV1SchemaToJSON(value), {
        tag: "rana-dtacogo-v1",
      } as const);
    case "simulate_rainfall":
      return Object.assign({}, SimulateRainfallSchemaToJSON(value), {
        tag: "simulate_rainfall",
      } as const);
    case "simulate_rainfall_standard_events":
      return Object.assign({}, SimulateRainfallStandardEventsSchemaToJSON(value), {
        tag: "simulate_rainfall_standard_events",
      } as const);
    case "simulation_tracker":
      return Object.assign({}, SimulationTrackerSchemaToJSON(value), {
        tag: "simulation_tracker",
      } as const);
    default:
      return value;
  }
}
